( function( $, document, window ) {
    'use strict';

    $( function() {
        $('.js-capabilities-carousel').each(function () {
            const sliderContainer = $(this);
            const sliderEl = $('.swiper', sliderContainer)[0];
            const $buttons = $('.capability-item__button', sliderContainer);
            const mq = window.matchMedia("(min-width: 1024px)");
            let swiper;

            function getActiveIndex() {
                let activeIndex = 0;
                $buttons.each(function (i) {
                    if ($(this).hasClass('is-active')) {
                        activeIndex = i;
                        return false;
                    }
                });
                return activeIndex;
            }

            function initSwiper() {
                if (mq.matches) {
                    $buttons.each(function () {
                        $(this).siblings('.capability-item__accordion').stop(true, true).hide();
                    });

                    if (!swiper) {
                        swiper = new Swiper(sliderEl, {
                            direction: 'horizontal',
                            slidesPerView: 1,
                            effect: 'fade',
                        });
                    }

                    swiper.slideTo(getActiveIndex(), 0);
                } else {
                    if (swiper) {
                        swiper.destroy(true, true);
                        swiper = null;
                    }

                    $buttons.each(function () {
                        const $accordion = $(this).siblings('.capability-item__accordion');
                        if ($(this).hasClass('is-active')) {
                            $accordion.stop(true, true).show();
                        } else {
                            $accordion.stop(true, true).hide();
                        }
                    });
                }
            }

            $buttons.on('click', function () {
                const $btn = $(this);
                const index = $buttons.index($btn);

                if (mq.matches) {
                    $buttons.removeClass('is-active');
                    $btn.addClass('is-active');
                    swiper.slideTo(index);
                } else {
                    const $accordion = $btn.siblings('.capability-item__accordion');
                    const isActive = $btn.hasClass('is-active');

                    $buttons.each(function () {
                        $(this).removeClass('is-active');
                        $(this).siblings('.capability-item__accordion').slideUp(400);
                    });

                    if (!isActive) {
                        $btn.addClass('is-active');
                        $accordion.slideDown(400);
                    }
                }
            });

            initSwiper();
            mq.addEventListener('change', initSwiper);
        });
    } );
} )( jQuery, document, window );